import { EditButton, DeleteButton, Stack } from "@pankod/refine-mui";

export default {
  title: "Servizi sistemazioni",
  resource: "accommodation-services",
  canCreate: true,
  columns: [
    { field: "name", headerName: "Nome", flex: 1, minWidth: 300 },
    {
      headerName: "Azioni",
      field: "actions",
      minWidth: 50,
      renderCell: function render(params) {
        return (
          <Stack direction="row" spacing={1}>
            <EditButton hideText recordItemId={params.row.id} />
            <DeleteButton hideText recordItemId={params.row.id} />
          </Stack>
        );
      },
    },
  ],
};
